import { BusinessUnit, BusinessUnitRegion } from "@/modules/User/types/types";

/**
 * Organiza a árvore de unidades de negócio em um array plano, incluindo todas as filhas.
 */
export const flattenBusinessUnits = (
  businessUnits: BusinessUnit[]
): BusinessUnit[] => {
  const units: BusinessUnit[] = [];

  for (const bu of businessUnits) {
    units.push(bu);

    if (bu.children) {
      units.push(...flattenBusinessUnits(bu.children));
    }
  }

  return units;
};

/**
 * Extrai todas as unidades de negócio da estrutura de classificação por região/segmento
 * e as organiza em um array plano (incluindo filhas).
 */
export const flattenClassifiedBusinessUnits = (
  businessUnits: BusinessUnitRegion[]
): BusinessUnit[] => {
  const allBusinessUnits: BusinessUnit[] = [];

  for (const region of businessUnits) {
    for (const segment of region.segments) {
      allBusinessUnits.push(...flattenBusinessUnits(segment.businessUnits));
    }
  }

  return allBusinessUnits;
};

/**
 * Padroniza a extração de unidades de negócio para facilitar o consumo em componentes como o seletor de BUs.
 * Lida tanto com a árvore de unidades em array plano quanto com a estrutura de classificação por região/segmeno.
 */
export const destructureAllBusinessUnitsChildren = (
  businessUnits?: BusinessUnit[],
  businessUnitClassification?: BusinessUnitRegion[]
): BusinessUnit[] => {
  const fromFlat = businessUnits ? flattenBusinessUnits(businessUnits) : [];
  const fromClassified = businessUnitClassification
    ? flattenClassifiedBusinessUnits(businessUnitClassification)
    : [];

  return [...fromFlat, ...fromClassified];
};
